// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, of } from 'rxjs';

// HS Code
import { EnrichedUserDetailsBaseService } from './enriched-user-details-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class EnrichedUserDetailsMockService extends EnrichedUserDetailsBaseService {

  override areEnrichedDetailsRequired(): Observable<boolean> {
    return of(false);
  }

  getUserDetails(companyId: string | null): void {
    throw new Error('Method not implemented.');
  }

  updateUserDetails(userDetailValues: string[], userId: string): void {
    throw new Error('Method not implemented.');
  }
}
